/* eslint-disable import/no-anonymous-default-export */
export default (adminYearlyCost = [], action) => {
  switch (action.type) {
    case "ADMIN_STOCK_RECEIVED_YEARLY":
      return action.payload;

    default:
      return adminYearlyCost;
  }
};
